<template>
    <main class="main">
        <div class="container-fluid px-0" data-layout="container">

            <aside-main/>

            <header-main/>

            <div class="content">
                
                <div class="card-header mb-5 d-flex flex-between-center">
                    <div class="d-flex align-items-center">
                        <h2 class="text-bold text-1100">Статистика</h2>
                    </div>

                    <div class="d-flex">
                        <button
                            @click="exportExcel"
                            :disabled="!items.length"
                            type="button"
                            class="btn btn-primary me-1 mb-1 float_right">
                            Экспорт в Excel
                        </button>
                    </div>
                </div>

                <div class="row align-items-center justify-content-between g-3 mb-3" v-show="!preloader">

                    <div class="col-sm-6 col-md-6">
                        <div class="form-icon-container">
                            <date-range-picker
                                @update="changeSearch"
                                :locale-data="datepiker"
                                :opens="pikerparams.opens"
                                :always-show-calendars="pikerparams.showcalendars"
                                :close-on-esc="pikerparams.closeonesc"
                                :auto-apply="pikerparams.autoapply"
                                :time-picker="pikerparams.timePicker"
                                :time-picker24-hour="pikerparams.timePicker24Hour"
                                v-model="search.date"
                                class="daterange-picker-medium">
                                <template #ranges="ranges">
                                  <div class="ranges">
                                    <ul>
                                      <li 
                                        v-for="(range, name, key) in pikerranges" 
                                        :key="name" 
                                        @click="ranges.clickRange(range, key)">
                                            {{name}}
                                      </li>
                                    </ul>
                                  </div>
                                </template>
                            </date-range-picker>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-6">
                        <div class="form-icon-container">
                            <vue-select
                                @input="changeSearch"
                                v-model="search.campaign"
                                :options="utils.campaigns" 
                                placeholder="Компания"
                                label="name">
                                <template v-slot:option="option">
                                    <span>{{ option.name }}</span>
                                </template>
                                <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching && search.length >= 3">
                                        Ничего не найдено по запросу <em>{{ search }}</em>.
                                    </template>
                                    <span v-else>Введите не менее 3 символов</span>
                                </template>
                            </vue-select>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-6">
                        <div class="form-icon-container" id="merchant_block">
                            <vue-select
                                @input="changeSearch"
                                v-model="search.merchant"
                                :options="utils.merchants" 
                                placeholder="Валюта"
                                label="currency">
                                <template v-slot:option="option">
                                    <span>{{ option.currency }}</span>
                                </template>
                                <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching && search.length >= 3">
                                        Ничего не найдено по запросу <em>{{ search }}</em>.
                                    </template>
                                    <span v-else>Введите не менее 3 символов</span>
                                </template>
                            </vue-select>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-6">
                        <div class="form-icon-container" id="group_by_block">
                            <vue-select
                                @input="changeSearch"
                                v-model="search.group_by"
                                :options="utils.group_by" 
                                placeholder="Группировка по"
                                label="name">
                                <template v-slot:no-options="{ search, searching }">
                                  <template v-if="searching">
                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                  </template>
                                </template>
                            </vue-select>
                        </div>
                    </div>
                </div>

                <div class="card-body p-0 spinner-center" v-if="preloader">
                    <div class="p-4 code-to-copy">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>

                <div class="mx-n4 mx-lg-n6 px-4 px-lg-6 mb-9 bg-white border-y border-300 mt-2 position-relative top-1" v-show="!preloader">
                    <div class="table-responsive scrollbar ms-n1 ps-1">
                    
                        <div class="table table-responsive-small fs--1">
                            <datatable
                                :filter="search.search_change"
                                :columns="columns" 
                                :data="getItems"
                                :per-page="pager.per_page">
                                <template scope="{ row, columns }">
                                    <tr>
                                        <td>
                                            <template v-if="search.group_by.key == 'country' && utils.countries.find(el => el.key == row.key)">
                                                {{ utils.countries.find(el => el.key == row.key).name }}
                                            </template>
                                            <template v-else>
                                                {{ row.key }}
                                            </template>
                                        </td>
                                        <td>{{ row.installs }}</td>
                                        <td>{{ row.clicks }}</td>
                                        <td>{{ row.unique }}</td>
                                        <td>{{ row.registrations }}</td>
                                        <td>{{ row.revenue }}</td>
                                        <td>{{ row.deposits }}</td>
                                        <td>{{ row.withdraws }}</td>
                                        <td>{{ parseFloat(row.deposit_amount).toFixed(2) }}</td>
                                        <td>{{ parseFloat(row.withdraw_amount).toFixed(2) }}</td>
                                        <td>{{ parseInt(row.deposits_first || 0) }}</td>
                                        <td>{{ parseFloat(row.deposit_first_amount || 0).toFixed(2) }}</td>
                                        <td>{{ parseInt(row.deposits_repeated || 0) }}</td>
                                        <td>{{ parseFloat(row.deposit_repeated_amount || 0).toFixed(2) }}</td>
                                    </tr>
                                </template>
                            </datatable>
                        </div>

                        <div class="col-auto d-flex">
                            <ul class="mb-3 pagination">
                                <datatable-pager v-model="pager.page" type="abbreviated"></datatable-pager>
                            </ul>
                        </div>

                    </div>
                </div>
                
                <footer-main/>

            </div>

        </div>
    </main>
</template>

<script>

let { json2excel, excel2json } = require('js2excel')

export default {
    data () {
        return {
            preloader: true,
            pager: {
                per_page: 25,
                page: 0
            },
            items: [],
            items_count: 0,
            search: {
                search_change: null,
                campaign: null,
                merchant: null,
                group_by: {
                    name: 'Дате',
                    key: 'date'
                },
                date: {
                    startDate: this.$moment().set({date: this.$moment().get('date') - 30}).format('Y-MM-DD HH:mm:ss'),
                    endDate: this.$moment().format('Y-MM-DD HH:mm:ss')
                }
            },
            columns: [
                {label: 'Название', field: 'date', sortable: true},
                {label: 'Инсталлы', field: 'installs', sortable: true},
                {label: 'Клики', field: 'clicks', sortable: true},
                {label: 'Уники', field: 'unique', sortable: true},
                {label: 'Регистрации', field: 'registrations', sortable: true},
                {label: 'Прибыль', field: 'revenue', sortable: true},
                {label: 'Депозиты', field: 'deposits', sortable: true},
                {label: 'Выплаты', field: 'withdraws', sortable: true},
                {label: 'Сумма депозитов', field: 'deposit_amount', sortable: true},
                {label: 'Сумма выплат', field: 'withdraw_amount', sortable: true},
                {label: 'ФД', field: 'deposits_first', sortable: true},
                {label: 'Сумма ФД', field: 'deposit_first_amount', sortable: true},
                {label: 'РД', field: 'deposits_repeated', sortable: true},
                {label: 'Сумма РД', field: 'deposit_repeated_amount', sortable: true}
            ],
            utils: {
                merchants: [],
                campaigns: [],
                countries: [],
                group_by: [
                    {
                        name: 'Дата',
                        key: 'date'
                    },
                    {
                        name: 'Компания',
                        key: 'campaign'
                    },
                    {
                        name: 'Валюта',
                        key: 'currency'
                    },
                    {
                        name: 'Страна',
                        key: 'country'
                    },
                    {
                        name: 'Город',
                        key: 'city'
                    },
                    {
                        name: 'Девайс',
                        key: 'device'
                    },
                    {
                        name: 'Платформа',
                        key: 'platform'
                    },
                    {
                        name: 'Браузер',
                        key: 'browser'
                    }
                ]
            },
            datepiker: {
                direction: 'ltr',
                format: 'yyyy.mm.dd HH:MM',
                separator: ' - ',
                applyLabel: 'Применить',
                cancelLabel: 'Отмена',
                weekLabel: 'W',
                customRangeLabel: 'Настраиваемый диапазон',
                daysOfWeek: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                firstDay: 0
            },
            pikerparams: {
                showcalendars: true,
                closeonesc: true,
                autoapply: false,
                timePicker: true,
                timePicker24Hour: true,
                opens: 'right'
            },
            pikerranges: {
                'Один день': [this.$moment().set({date: this.$moment().get('date') - 1}).toDate(), this.$moment().toDate()],
                'Одна неделя': [this.$moment().set({date: this.$moment().get('date') - 7}).toDate(), this.$moment().toDate()],
                'Один месяц': [this.$moment().set({date: this.$moment().get('date') - 30}).toDate(), this.$moment().toDate()],
                'Два месяца': [this.$moment().set({date: this.$moment().get('date') - 60}).toDate(), this.$moment().toDate()],
                'Три месяца': [this.$moment().set({date: this.$moment().get('date') - 90}).toDate(), this.$moment().toDate()],
                'Пол года': [this.$moment().set({date: this.$moment().get('date') - 180}).toDate(), this.$moment().toDate()],
                'Один год': [this.$moment().set({date: this.$moment().get('date') - 365}).toDate(), this.$moment().toDate()]
            }
        }
    },
    methods: {
        async getItems ({ sortBy, sortDir, perPage, page }) {
            if(!this.utils.merchants.length) {
                await this.getMerchants()
            }
            this.preloader = true
            var items = await this.$axios.post('/statistics/items', JSON.stringify({
                pager: {
                    per_page: this.pager.per_page,
                    page: page - 1
                },
                sort: {
                    by: sortBy,
                    dir: sortDir
                },
                search: {
                    campaign: this.search.campaign ? this.search.campaign.id : null,
                    merchant: this.search.merchant.currency,
                    group_by: this.search.group_by ? this.search.group_by.key : null,
                    date: {
                        start: this.$moment(this.search.date.startDate).format('YYYY-MM-DD H:mm:ss'),
                        end: this.$moment(this.search.date.endDate).format('YYYY-MM-DD H:mm:ss')
                    }
                }
            }))
            .then((response) => {
                this.preloader = false
                this.setUser(response.data.user)
                return response.data
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })

            items.data.items.push({
                key: 'Всего',
                clicks: this.sumFields(items.data.items, 'clicks'),
                unique: this.sumFields(items.data.items, 'unique'),
                revenue: this.sumFields(items.data.items, 'revenue'),
                deposits: this.sumFields(items.data.items, 'deposits'),
                withdraws: this.sumFields(items.data.items, 'withdraws'),
                registrations: this.sumFields(items.data.items, 'registrations'),
                deposit_amount: this.sumFields(items.data.items, 'deposit_amount'),
                withdraw_amount: this.sumFields(items.data.items, 'withdraw_amount')
            })

            this.items = items.data.items

            if(items && items.status == 'success') {   
                this.items_count = items.data.count             
                return {
                    rows: items.data.items,
                    totalRowCount: items.data.count
                }
            }

            return {
                rows: [],
                totalRowCount: 0
            }
        },
        getCountries () {
            this.$axios.post('/utils/countries/items')
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':

                        for(let item in response.data) {
                            this.utils.countries.push({
                                name: response.data[item],
                                key: item
                            })
                        }

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)
                
                if(response && 'status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        getCampaigns () {
            this.$axios.post('/campaigns/items', JSON.stringify({
                search: {
                    name: null,
                    type: null,
                    status: null
                }
            }))
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':

                        for(let item of response.data.items) {
                            this.utils.campaigns.push({
                                name: item.name,
                                id: item.id
                            })
                        }

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                this.setUser(response.user)
                
                if(response && 'status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        async getMerchants () {
            await this.$axios.post(`/merchants/items`)
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":
                        for (let item of response.data) {
                            this.utils.merchants.push({
                                name: item.name,
                                currency: item.currency,
                                id: item.id
                            })
                        }

                        this.search.merchant = this.utils.merchants[0]

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    if('field' in response) {
                        this.errors[response.field] = response.message
                    } else {
                        this.$toast.error(response.message)
                    }
                }

                if(error.response.status == 404) {
                    this.$router.push({name: 'UsersStatusItems'})
                }
            })
        },
        exportExcel () {
            let data = this.items

            try {
                json2excel({
                    data,
                    name: 'statistics',
                    formateDate: 'yyyy-mm-dd'
                });
            } catch (e) {
                this.$toast.error('Export error')
            }
        },
        sumFields (data, key) {
            return data.reduce((accumulator, object) => {
                return accumulator + parseFloat(object[key])
            }, 0)
        },
        changeSearch () {
            this.search.search_change = String(Date.now())
        }
    },
    beforeMount() {
        this.getCountries()
        this.getCampaigns()
    }
}
</script>

<style lang="css" scoped>
    ::v-deep #merchant_block .vs__clear {
        display: none;
    }

    ::v-deep #group_by_block .vs__clear {
        display: none;
    }
</style>
